import { useSelector } from 'react-redux'
import { GDP_TAB } from '../../../constant'
import { ChartNominalGDP } from './ChartNominalGDP'
import { ChartRealGDP } from './ChartRealGDP'
import { selectTab } from './slice'

export const Content = () => {
  const tab = useSelector(selectTab)

  return tab === GDP_TAB.REAL_GDP.key ? <ChartRealGDP /> : <ChartNominalGDP />
}
